// extracted by mini-css-extract-plugin
module.exports = {"load":"Spinner_load__2Ppqg","loader":"Spinner_loader__3Ca3s","load8":"Spinner_load8__1lj2x"};